import * as angular from 'angular';

/** MIGRATED UI COMPONENTS **/
angular.module('ib-ui-banners-module', []);
angular.module('ib-ui-carousel-module', []);
angular.module('ib-ui-timer-module', []);
angular.module('ib-ui-automatic-invoice-module', []);
angular.module('ib-ui-quotas-nemuru-module', []);
angular.module('ib-ui-ios-list-component-module', []);


angular.module('ib-commons-ui-components-module', [
    'ib-commons-avios-constants',
    'ib-ui-bonds-summary-module',
    'ib-ui-box-information-module',
    'ib-ui-checkbox-accept-module',
    'ib-ui-daterangepicker-module',
    'ib-ui-city-selector-component-module',
    'ib-ui-fare-conditions-module',
    'ib-ui-flight-card-module',
    'ib-ui-loading-module',
    'ib-ui-steps-module',
    'ib-ui-summary-fare-module',
    'ib-ui-avios-summary-module',
    'ib-ui-avios-summary-banner-module',
    'ib-ui-total-price-module',
    'ib-ui-voucher-list-module',
    'ib-ui-warnings-module',
    'ib-ui-travel-info-module',
    'ib-notice-module',
    'ib-ui-titles-module',
    'ib-ui-buttons-sets-module',
    'ib-notice-module',
    'ib-ui-passenger-special-needs-module',
    'ib-ui-expiry-dates-select-module',
    'ib-ui-birth-date-module',
    'ib-ui-document-module',
    'ib-ui-countries-list-module',
    'ib-ui-gender-module',
    'ib-ui-prefix-and-phone-module',
    'ib-ui-prefix-city-module',
    'ib-ui-community-list-by-country-module',
    'ib-ui-province-module',
    'ib-ui-login-iframe',
    'ib-ui-login-reusable-iframe-component',
    'ib-ui-ios-list-component-module',
    'ib-ui-banners-module',
    'ib-ui-box-card-module',
    'ib-ui-attendance-voucher-card-module',
    'ib-ui-search-module',
    'ib-ui-collapse-details',
    'ib-ui-timer-module',
    'ib-ui-passenger-selector-module',
    'ib-ui-discount-offer-module',
    'ib-ui-carousel-module',
    'ib-ui-drop-down-list-module',
    'ib-ui-automatic-invoice-module',
    'ib-ui-quotas-nemuru-module'
]);
